import { Observable } from 'rxjs'
import { StateGateway } from './state-gateway'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'

@Injectable()
export class NetworkStateGateway extends StateGateway {
    constructor(private http: HttpClient) {
        super()
    }

    getAllStates(): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/GetStates'
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }

    getAllStateRegions(): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/getAllStateRegions'
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }
    getAllStatesforMailing(): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/getAllStatesforMailing'
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }

    getStateCodeByZipCode(zipCode: string): Observable<ValidatedSelectOptionModel[]> {
        return this.http.get<ValidatedSelectOptionModel[]>('../api/callstart/getStateAbbrByZipCode/' + zipCode)
    }

    getRegionCodeByState(state: string): Observable<number> {
        return this.http.get<number>('../api/getRegionCodeByState/' + state)
    }
}
